import { REPORTS_API } from "redux/api";

const generateQueryParams = (payload) => {
    let query = "";
    if(payload?.locationId){
        query+="&locationId="+payload?.locationId
    }else if(payload?.locationid){
        query+="&locationId="+payload?.locationid
    }

    if(payload?.startDate){
        query+="&startDate="+payload?.startDate
    }
    if(payload?.endDate){
        query+="&endDate="+payload?.endDate
    }

    if(payload?.tablePageNo){
        query+="&page="+payload?.tablePageNo
    }else if(payload?.page){
        query+="&page="+payload?.page
    }
    if(payload?.tableRecordLimit){
        query+="&size="+payload?.tableRecordLimit
    }else if(payload?.size){
        query+="&size="+payload?.size
    }
    if(payload?.searchQuery){
        query+="&search="+payload?.searchQuery
    }else if(payload?.search){
        query+="&search="+payload?.search
    }

    if (payload?.itemIds?.length > 0) {
        query += `&itemIds=${(payload?.itemIds || [])?.join(",")}`;
    } else if (payload?.categoryIds?.length > 0) {
        query += `&categoryIds=${(payload?.categoryIds || [])?.join(",")}`;
    }else if(payload?.groupByCategory){
        query+=`&groupByCategory=${payload?.groupByCategory}`
    }
    if(payload?.reason){
        query+=`&reason=${payload?.reason}`
    }
    if(payload?.offer){
        query+=`&offer=${payload?.offer}`
    }
    if(payload?.customerName || payload?.customerName==""){
        query+=`&customerName=${payload?.customerName}`

    }

    if(payload?.phoneNumber){
        query+=`&phoneNumber=%2B${payload?.phoneNumber}`

    }


    return "?"+query?.slice(1)
}

export const getSummaryInsightsCustomerVolume = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/customer/volume-summary${query}`,
    });
};

export const getSummaryInsightsCustomerByTenure = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/customerByTenure${query}`,
    });
};



export const getSummaryInsightsCustomersByTotalSpend= (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/customer/total-spend${query}`,
    });
};

export const getSummaryInsightsCustomersByAvgCoverSize= (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/avgCoverSize${query}`,
    });
};

export const getSummaryInsightsCustomersByLoyalty= (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/customer/loyalty-counts${query}`,
    });
};

export const getDetailedInsightsCustomerDetails= (params) => {
    // const { search, ...queryParams } = params;
    // const query = generateQueryParams(queryParams);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/customer-info?locationId=${params?.locationId}&startDate=${params?.startDate}&endDate=${params?.endDate}&search=${params?.search}&page=${params?.page}&size=${params?.size}`,
    });
};
export const getDetailedInsightsSummary= (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/summary${query}`,
    });
};

export const getDetailedInsightsDineIn= (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/dinein-customer${query}`,
    });
};

export const getDetailedInsightsOffPrem= (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/online-customer${query}`,
    });
};


export const getDetailedInsightsCustomersOrder= (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/customerOrderHistory${query}`,
    });
};



export const getDetailedInsightsLatestOrder= (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/latest-order-items${query}`,
    });
};


export const getDetailedInsightsCustomersTopFavItems= (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/customer/insights/favourite-items${query}`,
    });
};
